import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select'
import { checkboxData } from './checkboxData';
import './style.css'
import { useUserAuth } from '../../context/UserAuthContext';
import { useFormik } from 'formik';
import { weddingDjTtkSchema } from '../schemas';
import axios from "axios";
import { NumericFormat } from 'react-number-format';
import ThinksToKnowStatus from './ThinksToKnowStatus';

const WeddingDjTTK = () => {
    const [ttkEditMode, setTtkEditMode] = useState(false)
    const { user, language, token, currency } = useUserAuth();
    const merchant_id = user.uid;
    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
    const [merchant, setMerchant] = useState({});

    // const [data, setData] = useState({
    //     startingPrice: '',
    //     workingSince:[],
    //     TravelPreference:[],
    //      favouriteMusic:[],
    //      areaOfWork: [],

    // })

    // const areaofWorkingHandler = (e) => {
    //     setData({ ...data, areaOfWork: e })
    // }

    const areaOfWorkingOption = checkboxData.areaOfWorking;
    const workingSinceOption = checkboxData.workSinceOption;
    const favouriteMusicOption = checkboxData.favouriteMusic
    const travelPreferenceOption = checkboxData.travelPreference;

    const getSingleDocumentHandler = async () => {
        try {
            const res = await axios.get(
                `${base_url}/api/v1/thinkstoknow/${merchant_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
            );
            const data = res.data.data;
            const details = data[0].details;
            if (details) {
                setMerchant(details);
            }
        } catch (error) {
            console.log(`Error : ${error}`);
        }
    };
    useEffect(() => {
        if (!merchant_id) return
        getSingleDocumentHandler()
    }, [merchant_id, token])


    const formik = useFormik({
        initialValues: {
            startingPrice: Math.floor(merchant?.startingPrice * currency.value) || "",
            TravelPreference: merchant?.TravelPreference || [],
            workingSince: merchant?.workingSince || [],
            favouriteMusic: merchant?.favouriteMusic || [],
            areaOfWork: merchant?.areaOfWork || [],
        },
        validationSchema: weddingDjTtkSchema,
        onSubmit: async (values) => {
            try {
                const data = {
                    id: merchant_id,
                    details: { ...values, startingPrice: Math.floor(values?.startingPrice * currency.country_value) },
                };

                const res = await axios.post(`${base_url}/api/v1/thinkstoknow`, data, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (res.status === 201) {
                    toast.success("Things to know added successfully.");
                    setMerchant(values);
                    formik.setValues(values);
                    setTtkEditMode(false);
                } else if (res.status === 202) {
                    toast.success("Your update is pending approval by the admin.");
                    setTtkEditMode(false);
                } else {
                    toast.info(res.data.message || "Request submitted.");
                    setTtkEditMode(false);
                }

            } catch (error) {
                console.error(`Error ${error}`);
                toast.error('An error occurred while submitting the data.');
            }
        },
    });


    return (
        <div className="page-wrapper">
            <div className="container-fluid">
                 <ThinksToKnowStatus/>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div className='card-header  text-white text-center ' style={{ backgroundColor: '#085f9a' }}>
                                <h5> {language === 'en' ? 'Things to Know' : 'जानने योग्य जानकारी भरे'}</h5>
                            </div>
                            <div className='card-body'>
                                {
                                    merchant && (
                                        <>
                                            <div className='table-responsive'>
                                                <table className='table text-center' cellPadding={0} cellSpacing={0} style={{ border: '1px solid #fff ' }}>
                                                    <tbody className='ttk_preview'>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th style={{ width: '25%' }}>Working Since</th>
                                                            <th style={{ width: '25%' }}>Area Of Services</th>
                                                            <th style={{ width: '25%' }}>Starting Price</th>
                                                            <th style={{ width: '25%' }}>Music Genre You Specialize In?</th>

                                                        </tr>
                                                        <tr>
                                                            <td>{
                                                                merchant.workingSince?.map((item, index) => {
                                                                    return <p key={index}>{item.value}</p>
                                                                })
                                                            }</td>
                                                            <td>{
                                                                merchant.areaOfWork
                                                                    ?.map((item, index) => {
                                                                        return (<span key={index}>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span >{item.value} </span>
                                                                        </span>)
                                                                    })
                                                            }</td>
                                                            <td>
                                                                <NumericFormat
                                                                    value={Math.floor(
                                                                        currency.value * merchant.startingPrice
                                                                    )}
                                                                    displayType="text"
                                                                    thousandsGroupStyle={
                                                                        currency.symbol === "₹" ? "lakh" : "thousand"
                                                                    }
                                                                    thousandSeparator=","
                                                                    renderText={(formattedValue) => (
                                                                        <span>
                                                                            {currency.symbol}&nbsp;{formattedValue}
                                                                        </span>
                                                                    )}
                                                                />
                                                            </td>
                                                            <td>{
                                                                merchant.favouriteMusic
                                                                    ?.map((item, index) => {
                                                                        return <span key={index}>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span>{item.value} </span>
                                                                        </span>
                                                                    })
                                                            }</td>
                                                        </tr>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th>Travel Preference</th>
                                                        </tr>
                                                        <tr>
                                                            <td>{
                                                                merchant.TravelPreference
                                                                    ?.map((item, index) => {
                                                                        return (
                                                                            <span key={index}>
                                                                                <i className='fa fa-check text-success' />
                                                                                <span>{item.value} </span>
                                                                            </span>
                                                                        )
                                                                    })
                                                            }</td>

                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </div>
                                        </>
                                    )
                                }
                                <center >
                                    <button className='btn text-center text-white mb-2' style={{ backgroundColor: '#085f9a' }} onClick={() => setTtkEditMode(!ttkEditMode)}>{`${merchant ? 'Make Changes' : 'Tell me more about yourself'}`}</button>
                                </center>
                                {
                                    ttkEditMode && (
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className='row'>

                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Working Since <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={workingSinceOption}
                                                            selected
                                                            value={formik.values.workingSince}
                                                            onChange={(workingSince) => formik.setFieldValue('workingSince', workingSince)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.workingSince && formik.errors.workingSince ? (
                                                            <div className="text-danger">{formik.errors.workingSince}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Area of Services</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={areaOfWorkingOption}
                                                            selected
                                                            value={formik.values.areaOfWork}
                                                            onChange={(areaOfWork) => formik.setFieldValue('areaOfWork', areaOfWork)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.areaOfWork && formik.errors.areaOfWork ? (
                                                            <div className="text-danger">{formik.errors.areaOfWork}</div>
                                                        ) : null}
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <label htmlFor="inlineFormInputGroup">Starting Price <span className="text-danger">*</span></label>
                                                    <div className="input-group mb-2">
                                                        <div className="input-group-prepend">
                                                            <div className="input-group-text">{currency?.symbol}</div>
                                                        </div>
                                                        <input
                                                            type='number'
                                                            placeholder='Starting Price'
                                                            className='form-control'
                                                            name="startingPrice"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.startingPrice} />
                                                    </div>
                                                    {formik.touched.startingPrice && formik.errors.startingPrice ? (
                                                        <div className="text-danger">{formik.errors.startingPrice}</div>
                                                    ) : null}
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Music Genre You Specialize In?</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={favouriteMusicOption}
                                                            selected
                                                            value={formik.values.favouriteMusic}
                                                            onChange={(favouriteMusic) => formik.setFieldValue('favouriteMusic', favouriteMusic)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.favouriteMusic && formik.errors.favouriteMusic ? (
                                                            <div className="text-danger">{formik.errors.favouriteMusic}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Travel Preference</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={travelPreferenceOption}
                                                            selected
                                                            value={formik.values.TravelPreference}
                                                            onChange={(TravelPreference) => formik.setFieldValue('TravelPreference', TravelPreference)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.TravelPreference && formik.errors.TravelPreference ? (
                                                            <div className="text-danger">{formik.errors.TravelPreference}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='form-group'>
                                                <button className='btn text-white' type='submit' style={{ backgroundColor: '#085f9a' }}>Submit</button>
                                            </div>
                                        </form>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default WeddingDjTTK